export default __webpack_public_path__ + "static/media/Delete.f8247b27.svg";